import axiosInstance from "../config/axiosInstance";

const chatFavouriteService = {
  updateFavouriteStatus: async (sessionId: string, isFavourite: number) => {
    try {
      const { data } = await axiosInstance.put("/api/update/favouriteSession", {
        session_id: sessionId,
        is_favourite: isFavourite,
      });
      return data;
    } catch (error) {
      console.error("Error updating favourite status:", error);
      throw error;
    }
  },

  getFavouriteSessions: async (params: { page: number; limit: number }) => {
    try {
      const { data } = await axiosInstance.get("/api/getFavouriteSessions", {
        params,
      });
      return { data, params };
    } catch (error) {
      console.error("Error fetching favorite sessions:", error);
      throw error;
    }
  },

  unFavouriteAllSessions: async () => {
    try {
      const { data } = await axiosInstance.delete(
        "/api/update/unFavouriteAllSessions"
      );
      return data;
    } catch (error) {
      console.error("Error unfavouriting all sessions:", error);
      throw error;
    }
  },
};

export default chatFavouriteService;
